import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { colors } from '../../theming/theme';

const LinkItem = styled(Link)({
  color: colors.black,
});

export default LinkItem;
